(ns frontend.view.modals.select-entity.view
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [frontend.view.entity :as f-entity]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :select-entity-modal)

(defn form-ready?
  [state]
  (boolean (:target-id @state)))

(defn view
  [{:keys [shown? close-modal! props state _class-name topmost?]}]
  (let [{:keys [target-type on-select! create-on-fly?]} props]
    [modal/view
     {:visible?      (and shown? topmost?)
      :hide!         close-modal!
      :backdrop      "static"
      :close-button? true}
     (loc/tr :select-entity [(loc/tr target-type)])
     [labelled-input/view
      (cond-> {:editor-type               :editor.type/search
               :data-type                 :data.type/ref-single
               :label                     (loc/tr :select-entity [(loc/tr target-type)])
               :mandatory?                true
               :field/entity-types        [target-type]
               :field/select-entity-types [target-type]
               :value                     (:value-opt @state)
               :on-change                 (fn [_value option]
                                            (swap! state assoc
                                                   :target-id (:value option)
                                                   :value-opt option))}
        create-on-fly?
        (assoc :field/create-entity-types [target-type]
               :create! (fn [input-str]
                          (f-entity/open-creator!
                           target-type
                           {:start-value       input-str
                            :skip-success-msg? true
                            :on-ok!            (fn [{:keys [new-entity-id new-entity close-cb!]}]
                                                 (let [opt {:value new-entity-id
                                                            :label (entity/display-string new-entity)}]
                                                   (swap! state assoc
                                                          :target-id new-entity-id
                                                          :value-opt opt))
                                                 (when (fn? close-cb!) (close-cb!)))}))))]
     [:<>
      [modal/left-cancel-only close-modal! nil]
      [modal/right-single-button
       nil
       (not (form-ready? state))
       #(on-select! (:target-id @state) close-modal!)
       (loc/tr :select)
       nil]]]))
